
import React, {useState} from "react";
import './Header.css'
import {navLinksForBusiness} from "./NavLinks";
import {useProviderProfile} from "../ProviderProfileProvider";
import {LinkWithParams, useNavigateWithParams} from "../util/NavUtils";

/**
 * When the screen size is small, this is hamburger icon w/ dropdown for the nav links.
 * @constructor
 */
export const HeaderNavLinks = () => {

  const {business} = useProviderProfile();
  const navigate = useNavigateWithParams();

  const [navLinksOpen, setNavLinksOpen] = useState(false);

  return <div className={'HeaderNavLinkContainer'}>

    <button className={'HeaderNavLinks'}
            onClick={() => {
              setNavLinksOpen(open => !open)
            }}
            onBlur={() => {
              // Keeps the blur from happening before a click on an item.
              setTimeout(() => setNavLinksOpen(false), 100);
            }}>
      <img src={require('../images/icons/menu.png')} alt={'Menu'}
           style={{height: 30, width: 30}}/>
    </button>

    {/* this div is an anchor for the relatively positioned overlay*/}
    <div style={{position: "relative"}}>

      {navLinksOpen && <div className={'HeaderNavLinksOverlay'}>
        {navLinksForBusiness(business).map((navLink, i) => {
          return <LinkWithParams className={'HeaderNavLink'}
                                 key={'navlink-' + i}
                                 to={'/home/' + navLink.link}>
            {navLink.text}
          </LinkWithParams>
        })}
      </div>}
    </div>
  </div>
}